import React from "react";
import data from "../../data/videoReviews.json";
import VideoReviewCard from "./VideoReviewCard";

const VideoReviews = () => {
  return (
    <>
      <div className="section-header">
        <h3 className="highlighted-text">
          Student Video Reviews
        </h3>
      </div>
      <section className="video-reviews-section review-container section-bg">

        <div className="video-reviews-grid">
          {data.reviews
            .filter(r => r.active)
            .sort((a, b) => a.order - b.order)
            .map(review => (
              <VideoReviewCard key={review.id} review={review} />
            ))}
        </div>
      </section>

    </>
  );
};

export default VideoReviews;
